import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da4dad16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "email-submit" }

import { onMounted, reactive, ref } from 'vue'
import { bindEmail, sendEmailVerifyCode } from '@/api/user'
import { ERR_SUCCESS } from '@/api/config'
import { ElMessage } from 'element-plus/lib'
import Schema, { RuleItem } from 'async-validator'
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'email',
  props: ['email', 'hideDialog'],
  setup(__props) {

const formRef = ref(null)

const disabled = ref(false)
const loading = ref(false)
const btnContent = ref('获取验证码')
let timer: NodeJS.Timeout | null = null
let isTimerRunning = false // Flag to track whether the timer is currently running

const form = reactive({
  emailAccount: '',
  verifyNum: ''
})

// eslint-disable-next-line no-undef
const props = __props

onMounted(() => {
  form.emailAccount = props.email
})

const rules: { [key: string]: RuleItem[] } = {
  emailAccount: [
    { required: true, message: '请输入邮箱账号', trigger: 'blur', type: 'string' } as RuleItem,
    { type: 'email', message: '请输入正确的电子邮箱账号', trigger: 'blur' } as RuleItem
  ],
  verifyNum: [
    { required: true, message: '请输入验证码', trigger: 'blur', type: 'string' } as RuleItem,
    { len: 4, message: '请输入4位数字的验证码', trigger: 'blur', type: 'string' } as RuleItem
  ]
}

function startTimer () {
  let count = 5
  isTimerRunning = true // Set the flag to indicate that the timer is running
  timer = setInterval(() => {
    if (count <= 0) {
      clearInterval(timer!)
      timer = null
      btnContent.value = '获取验证码'
      isTimerRunning = false // Reset the flag when the timer is stopped
      return
    }
    btnContent.value = `${count} 秒后重新获取`
    count--
  }, 1000)
}

function sendSmsCode () {
  const validator = new Schema({
    emailAccount: rules.emailAccount
  })

  validator.validate({ emailAccount: form.emailAccount }, async (errors) => {
    if (!errors) {
      const { code, message } = await sendEmailVerifyCode({ email: form.emailAccount })
      if (code === ERR_SUCCESS) {
        ElMessage.success(message)
      } else {
        if (code === 506) { ElMessage.error('该邮箱已经被其他账户绑定，请检查或者更换邮箱地址。') } else { ElMessage.error(message) }
      }
      if (isTimerRunning) {
        return
      }
      loading.value = true
      disabled.value = true
      setTimeout(() => {
        loading.value = false
        btnContent.value = '180 秒重新获取'
        disabled.value = false
        startTimer()
      }, 1000) // Simulate 3 seconds for SMS code to be sent
    } else {
      ElMessage.error(errors[0].message)
    }
  })
}

async function validationCode () {
  // eslint-disable-next-line @typescript-eslint/camelcase
  const params = { email: form.emailAccount, email_verify_code: form.verifyNum }
  try {
    const validator = new Schema(rules)

    await validator.validate(form, async (errors) => {
      if (!errors) {
        const { code, message } = await bindEmail(params)
        if (code === ERR_SUCCESS) {
          await store.dispatch('user/getInfo')
          ElMessage.success(message)
          props.hideDialog()
        } else {
          ElMessage.error(message)
        }
      } else {
        // Handle validation errors
        ElMessage.error(errors[0].message)
      }
    })
  } catch (error) {
    ElMessage.error('请正确填写相关字段信息!')
  }
}

function validateAndSubmit () {
  validationCode()
}

function cancel () {
  if (timer) {
    clearInterval(timer)
    isTimerRunning = false
  }
  props.hideDialog()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: form,
    rules: rules,
    ref_key: "formRef",
    ref: formRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "邮箱号",
        prop: "emailAccount"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            class: "emailAccount",
            modelValue: form.emailAccount,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.emailAccount) = $event)),
            placeholder: "请输入邮箱账号",
            clearable: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "验证码",
        prop: "verifyNum"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            class: "verifyNum",
            modelValue: form.verifyNum,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.verifyNum) = $event)),
            placeholder: "请输入验证码",
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            disabled: disabled.value || loading.value,
            loading: loading.value,
            onClick: sendSmsCode
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(btnContent.value), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _withModifiers(validateAndSubmit, ["stop"])
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})